// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  maintenance: '/maintenance',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  map: '/map',
  tourPlanningWizard: '/tour-planning-wizard',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    file: path(ROOTS_DASHBOARD, '/file'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
  student: {
    root: path(ROOTS_DASHBOARD, '/student'),
    list: path(ROOTS_DASHBOARD, '/student/list'),
    new: path(ROOTS_DASHBOARD, '/student/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/student/${id}`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/student/${id}/detail`),
    transportationNeedCheck: (id: string) =>
      path(ROOTS_DASHBOARD, `/student/transportation-need-check/${id}`),
  },
  school: {
    root: path(ROOTS_DASHBOARD, '/school'),
    list: path(ROOTS_DASHBOARD, '/school/list'),
    new: path(ROOTS_DASHBOARD, '/school/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/school/${id}`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/school/${id}/detail`),
  },
  schoolCenter: {
    root: path(ROOTS_DASHBOARD, '/schoolcenter'),
    list: path(ROOTS_DASHBOARD, '/schoolcenter/list'),
    new: path(ROOTS_DASHBOARD, '/schoolcenter/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/schoolcenter/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/schoolcenter/${id}/edit`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/schoolcenter/${id}/detail`),
  },
  tour: {
    root: path(ROOTS_DASHBOARD, '/tour'),
    list: path(ROOTS_DASHBOARD, '/tour/list'),
    new: path(ROOTS_DASHBOARD, '/tour/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/tour/${id}`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/tour/${id}/detail`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/tour/${id}/edit`),
  },
  tourPlan: {
    root: path(ROOTS_DASHBOARD, '/tour-plan'),
    list: path(ROOTS_DASHBOARD, '/tour-plan/list'),
    transform: (id: string) => path(ROOTS_DASHBOARD, `/tour-plan/transform/${id}`),
    view: (id: string) => path(ROOTS_DASHBOARD, `/tour-plan/${id}`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/tour-plan/${id}/detail`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/tour-plan/${id}/edit`),
  },
  transportationCompany: {
    root: path(ROOTS_DASHBOARD, '/transportation-company'),
    list: path(ROOTS_DASHBOARD, '/transportation-company/list'),
    new: path(ROOTS_DASHBOARD, '/transportation-company/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/transportation-company/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/transportation-company/${id}/edit`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/transportation-company/${id}/detail`),
  },
  employee: {
    root: path(ROOTS_DASHBOARD, '/employee'),
    list: path(ROOTS_DASHBOARD, '/employee/list'),
    new: path(ROOTS_DASHBOARD, '/employee/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/employee/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/employee/${id}/edit`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/employee/${id}/detail`),
  },
  vehicle: {
    root: path(ROOTS_DASHBOARD, '/vehicle'),
    list: path(ROOTS_DASHBOARD, '/vehicle/list'),
    new: path(ROOTS_DASHBOARD, '/vehicle/new'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/vehicle/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/vehicle/${id}/edit`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/vehicle/${id}/detail`),
  },
  studentApplication: {
    root: path(ROOTS_DASHBOARD, '/student-application'),
    list: path(ROOTS_DASHBOARD, '/student-application/list'),
    view: (id: string) => path(ROOTS_DASHBOARD, `/student-application/${id}`),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/student-application/${id}/edit`),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/student-application/${id}/detail`),
  },
  employeeApp: {
    root: path(ROOTS_DASHBOARD, '/employee-app'),
    employeeMessage: path(ROOTS_DASHBOARD, '/employee-app/messages'),
    employeeAppExport: path(ROOTS_DASHBOARD, '/employee-app/export'),
    employeeAppTrackComparison: path(ROOTS_DASHBOARD, '/employee-app/comparison'),
    detail: (id: string) => path(ROOTS_DASHBOARD, `/employee-app/messages/${id}/detail`),
  },
  basicSetting: {
    root: path(ROOTS_DASHBOARD, '/basic-setting'),
    schoolVacationTemplate: {
      root: path(ROOTS_DASHBOARD, '/basic-setting/school-vacation-template'),
      list: path(ROOTS_DASHBOARD, '/basic-setting/school-vacation-template/list'),
      new: path(ROOTS_DASHBOARD, '/basic-setting/school-vacation-template/new'),
      edit: (id: string) =>
        path(ROOTS_DASHBOARD, `/basic-setting/school-vacation-template/${id}/edit`),
    },
    lotConfig: path(ROOTS_DASHBOARD, '/basic-setting/lot-config'),
    tourBundle: {
      root: path(ROOTS_DASHBOARD, '/basic-setting/tour-bundle'),
      list: path(ROOTS_DASHBOARD, '/basic-setting/tour-bundle/list'),
      new: path(ROOTS_DASHBOARD, '/basic-setting/tour-bundle/new'),
      view: (id: string) => path(ROOTS_DASHBOARD, `/basic-setting/tour-bundle/${id}`),
      edit: (id: string) => path(ROOTS_DASHBOARD, `/basic-setting/tour-bundle/${id}/detail`),
    },
    schoolConfig: path(ROOTS_DASHBOARD, '/basic-setting/school-config'),
    transportationPeriodConfig: {
      root: path(ROOTS_DASHBOARD, '/basic-setting/transportation-period'),
      list: path(ROOTS_DASHBOARD, '/basic-setting/transportation-period/list'),
      new: path(ROOTS_DASHBOARD, '/basic-setting/transportation-period/new'),
      // view: (id: string) => path(ROOTS_DASHBOARD, `/basic-setting/transportation-period/${id}`),
      edit: (id: string) =>
        path(ROOTS_DASHBOARD, `/basic-setting/transportation-period/${id}/detail`),
    },
    placeManagement: path(ROOTS_DASHBOARD, '/basic-setting/place-management'),
    roadblockManagement: path(ROOTS_DASHBOARD, '/basic-setting/roadblock-management'),
    excelImport: {
      root: path(ROOTS_DASHBOARD, '/basic-setting/excel-import'),
      student: path(ROOTS_DASHBOARD, '/basic-setting/excel-import/students'),
      employee: path(ROOTS_DASHBOARD, '/basic-setting/excel-import/employees'),
      vehicle: path(ROOTS_DASHBOARD, '/basic-setting/excel-import/vehicles'),
      publicTransportation: path(
        ROOTS_DASHBOARD,
        '/basic-setting/excel-import/public-transportation'
      ),
    },
    timeMatrix: path(ROOTS_DASHBOARD, '/basic-setting/time-matrix'),
  },
  globalExport: {
    root: path(ROOTS_DASHBOARD, '/export'),
  },
  tourTender: {
    root: path(ROOTS_DASHBOARD, '/tour-tender'),
  },
  interkommunalerLastenausgleich: {
    root: path(ROOTS_DASHBOARD, '/interkommunaler-lastenausgleich'),
  },
};

export const PATH_DOCS = {
  root: 'https://www.terraplan.com',
  changelog: 'https://www.terraindividual.de/changelog',
};

export const PATH_FREE_VERSION = 'https://mui.com/store/items/minimal-dashboard-free/';

export const PATH_FIGMA_PREVIEW =
  'https://www.figma.com/file/OBEorYicjdbIT6P1YQTTK7/%5BPreview%5D-Minimal-Web.15.10.22?node-id=0%3A1';
